export const getErrorMessage = (name) => {
  const errors = {
    customAmount: "Lägsta möjliga belopp är 50 kr.",
    phone: "Vänligen använd mellan 8 och 25 siffror.",
  };

  if (errors[name]) {
    return errors[name];
  }
  
  return "Fältet är felaktigt";
};
